import { RowType } from "PFApp/booking/types/row";
import { Bar, Row } from "PFApp/booking/types/row";
import { ProjectItem } from "PFCore/hooks/queries/bookings/projects/use_projects_entries";
import { ProfileBookingsIndex } from "PFCore/hooks/queries/profile";

import { getChildrenCount, getStateFromChildren } from "../../../helpers";
import separateOverlappingBars from "../../../helpers/separate_overlapping_bars";

export const getRoleBars = (row: Row): Bar[][] => {
  const { original } = row;
  if (!("activity" in original)) {
    return [];
  }
  if (!original.activity.availability) {
    return [];
  }
  const bars: Bar[] = (original.activity.availability?.ranges || [original.activity.availability])
    .filter(({ start, end }) => !!start && !!end)
    .map((bar) => ({
      ...bar,
      start: bar.start!,
      end: bar.end!,
      state: getStateFromChildren(getChildrenCount(row))
    }));
  return separateOverlappingBars(bars);
};

export const getEngagementBars = (row: Row): Bar[][] => {
  const { original } = row;
  if (!("activity" in original)) {
    return [];
  }
  const { duration } = original.activity;
  if (!duration) {
    return [];
  }
  return [
    [
      {
        start: duration.start_date,
        end: duration.end_date,
        state: getStateFromChildren(getChildrenCount(row))
      }
    ]
  ];
};

export const getBookingBars = (
  row: Row,
  parentRow: Row | null,
  bookings: ProfileBookingsIndex[string | number],
  isSummary: boolean
): Bar[][] => {
  const checkIfIsRelatedToParentRowActivity = (activityId) =>
    parentRow &&
    [RowType.Role, RowType.Engagement].includes(parentRow.type) &&
    activityId === (parentRow.original as ProjectItem).activity.id;

  const bars = (bookings || []).map(
    ({
      start_date: start,
      end_date: end,
      booking_category_id: categoryId,
      id,
      duration,
      title,
      calculated_load: calculatedLoad,
      activity_id: activityId,
      state
    }) =>
      ({
        id,
        duration,
        calculatedLoad,
        start,
        end,
        categoryId,
        title,
        isRelatedToParentRowActivity: checkIfIsRelatedToParentRowActivity(activityId),
        activityId,
        state
      } as Bar)
  );
  if (isSummary) {
    return [bars];
  }
  const barsRelatedToParentActivity = bars.filter(
    ({ isRelatedToParentRowActivity }) => isRelatedToParentRowActivity
  );
  const barsNotRelatedToParentActivity = bars.filter(
    ({ isRelatedToParentRowActivity }) => !isRelatedToParentRowActivity
  );
  return [
    ...separateOverlappingBars(barsRelatedToParentActivity),
    ...separateOverlappingBars(barsNotRelatedToParentActivity)
  ];
};
